import React, { Component } from 'react';

import { withRouteOptions } from 'components/hocs/withRouteOptions';
import TrainerEventsTable from './TrainerEventsTable';
import { defaultTrainerEventsFilters } from 'constants/defaultFilters';

@withRouteOptions
export default class TrainerEvents extends Component {
    static routeOptions = {
        title: 'menu.trainerEvents'
    }

    state = {
        filters: defaultTrainerEventsFilters
    }

    changeFilters = filters => {
        this.setState({ filters });
    }

    render() {
        return (
            <TrainerEventsTable
                filters={this.state.filters}
                defaultFilters={defaultTrainerEventsFilters}
                onFiltersChange={this.changeFilters}
                {...this.props}
            />
        )
    }
}
